module.exports = __webpack_public_path__ + "img/glogo252.3429b391.png";